import React from 'react';

import AtlaskitPopup from '@atlaskit/popup';

import { useFeedbackState } from '../Feedback.reducer';
import Trigger from './Trigger';

export default function Popup(): JSX.Element {
  const state = useFeedbackState();

  return (
    <AtlaskitPopup
      placement='left-start'
      isOpen={state.screen.name !== 'popup-closed'}
      trigger={(triggerProps) => <Trigger triggerProps={triggerProps} />}
      content={() => state.screen.content}
      shouldRenderToParent
    />
  );
}
